// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-light: #e5e7eb;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.company-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.company-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

.company-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-light);
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
}

.company-title h2 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.5rem;
  font-weight: 600;
}

.company-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.5rem;
}
.company-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.company-status.inactive {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.company-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.detail-item .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.detail-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.detail-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}
.detail-item p a {
  color: var(--primary-color);
  text-decoration: none;
}
.detail-item p a:hover {
  text-decoration: underline;
}

.role-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}
.role-badge.enabled {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.role-badge.disabled {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}
.role-badge.success {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.role-badge.pending {
  background-color: rgba(245, 158, 11, 0.1);
  color: var(--warning-color);
}

.payment-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}
.payment-status.success {
  background-color: rgba(34, 197, 94, 0.1);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.2);
}
.payment-status.pending {
  background-color: rgba(251, 191, 36, 0.1);
  color: #d97706;
  border: 1px solid rgba(251, 191, 36, 0.2);
}
.payment-status.failed {
  background-color: rgba(239, 68, 68, 0.1);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.2);
}
.payment-status.free-trial {
  background-color: rgba(59, 130, 246, 0.1);
  color: #2563eb;
  border: 1px solid rgba(59, 130, 246, 0.2);
}
.payment-status.unknown {
  background-color: rgba(107, 114, 128, 0.1);
  color: #6b7280;
  border: 1px solid rgba(107, 114, 128, 0.2);
}

.company-permissions-section {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--border-light);
}
.company-permissions-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.company-permissions-section .section-header .section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.company-permissions-section .section-header .section-title .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
}
.company-permissions-section .section-header .section-title h3 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.25rem;
  font-weight: 600;
}

.permissions-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(200px, 1fr));
  gap: 1rem;
}
.permissions-grid .permission-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  transition: var(--transition);
}
.permissions-grid .permission-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.permissions-grid .permission-item .permission-details {
  flex: 1 1;
}
.permissions-grid .permission-item .permission-details .permission-name {
  font-weight: 600;
  color: var(--text-dark);
  font-size: 0.95rem;
}
.permissions-grid .permission-item .toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  cursor: default;
}
.permissions-grid .permission-item .toggle-switch input {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.permissions-grid .permission-item .toggle-switch input:checked + .slider {
  background-color: var(--primary-color, #3b82f6);
}
.permissions-grid .permission-item .toggle-switch input:checked + .slider::before {
  transform: translateX(26px);
}
.permissions-grid .permission-item .toggle-switch .slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  border-radius: 24px;
  transition: all 0.3s ease;
}
.permissions-grid .permission-item .toggle-switch .slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.court-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}
.court-details-grid .court-detail-item {
  padding: 1rem;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  transition: var(--transition);
}
.court-details-grid .court-detail-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.court-details-grid .court-detail-item .court-name {
  font-weight: 600;
  color: var(--text-dark);
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
.court-details-grid .court-detail-item .court-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.court-details-grid .court-detail-item .court-info .court-state,
.court-details-grid .court-detail-item .court-info .court-code {
  font-size: 0.85rem;
  color: var(--text-medium);
}

.unique-names-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}
.unique-names-grid .unique-name-item {
  padding: 0.75rem 1rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  text-align: center;
  transition: var(--transition);
}
.unique-names-grid .unique-name-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(67, 97, 238, 0.15);
}

.subscription-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}
.subscription-details .subscription-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.subscription-details .subscription-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}

.company-actions {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--border-light);
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}
.company-actions .edit-company-btn,
.company-actions .back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  border: none;
}
.company-actions .edit-company-btn {
  background-color: var(--primary-color);
  color: white;
}
.company-actions .edit-company-btn:hover {
  background-color: #3c5ce6;
  transform: translateY(-1px);
}
.company-actions .back-btn {
  background-color: transparent;
  color: var(--text-medium);
  border: 1px solid var(--border-light);
}
.company-actions .back-btn:hover {
  background-color: var(--bg-light);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.error-message {
  color: var(--danger-color);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .company-detail-container {
    padding: 1rem;
  }
  .company-card {
    padding: 1.5rem;
  }
  .company-details-grid {
    grid-template-columns: 1fr;
  }
  .permissions-grid {
    grid-template-columns: 1fr;
  }
  .court-details-grid {
    grid-template-columns: 1fr;
  }
  .unique-names-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
  .subscription-details {
    grid-template-columns: 1fr;
  }
  .company-actions {
    flex-direction: column;
  }
  .company-actions .edit-company-btn,
  .company-actions .back-btn {
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .company-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  .company-header .avatar {
    margin-right: 0;
  }
  .detail-item .icon {
    margin-top: 0;
  }
  .permission-item {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
    text-align: center;
  }
  .permission-item .permission-icon {
    align-self: center;
  }
  .court-detail-item {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CompanyDetailsPage/CompanyDetailsPage.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AACF;;AAGA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4CAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAAF;;AAIE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AADJ;;AAKA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAIE;EACE,yCAAA;EACA,2BAAA;AAFJ;AAKE;EACE,wCAAA;EACA,0BAAA;AAHJ;;AAOA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAJF;AAME;EACE,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAJJ;AAOE;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AALJ;AAQE;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AANJ;AAQI;EACE,2BAAA;EACA,qBAAA;AANN;AAQM;EACE,0BAAA;AANR;;AAYA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AATF;AAWE;EACE,yCAAA;EACA,2BAAA;AATJ;AAYE;EACE,wCAAA;EACA,0BAAA;AAVJ;AAaE;EACE,yCAAA;EACA,2BAAA;AAXJ;AAcE;EACE,yCAAA;EACA,2BAAA;AAZJ;;AAiBA;EAQE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AArBF;AAuBE;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;AArBJ;AAwBE;EACE,yCAAA;EACA,cAAA;EACA,yCAAA;AAtBJ;AAyBE;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;AAvBJ;AA0BE;EACE,yCAAA;EACA,cAAA;EACA,yCAAA;AAxBJ;AA2BE;EACE,0CAAA;EACA,cAAA;EACA,0CAAA;AAzBJ;;AA8BA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AA3BF;AA6BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AA3BJ;AA6BI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA3BN;AA6BM;EACE,2BAAA;EACA,kBAAA;AA3BR;AA8BM;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AA5BR;;AAkCA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;AA/BF;AAiCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AA/BJ;AAiCI;EACE,yCAAA;AA/BN;AAkCI;EACE,SAAA;AAhCN;AAkCM;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;AAhCR;AA0EI;EACF,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAxEF;AA0EE;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAxEJ;AA0EI;EACE,+CAAA;AAxEN;AA0EM;EACE,2BAAA;AAxER;AA6EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AA3EJ;AA6EI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AA3EN;;AAmFA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAhFF;AAkFE;EACE,aAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AAhFJ;AAkFI;EACE,yCAAA;AAhFN;AAmFI;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AAjFN;AAoFI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAlFN;AAoFM;;EAEE,kBAAA;EACA,yBAAA;AAlFR;;AAyFA;EACE,aAAA;EACA,2DAAA;EACA,YAAA;AAtFF;AAwFE;EACE,qBAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;AAtFJ;AAwFI;EACE,2BAAA;EACA,6CAAA;AAtFN;;AA4FA;EACE,aAAA;EACA,2DAAA;EACA,WAAA;AAzFF;AA4FI;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AA1FN;AA6FI;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AA3FN;;AAgGA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AA7FF;AA+FE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;AA7FJ;AAgGE;EACE,sCAAA;EACA,YAAA;AA9FJ;AAgGI;EACE,yBAAA;EACA,2BAAA;AA9FN;AAkGE;EACE,6BAAA;EACA,yBAAA;EACA,qCAAA;AAhGJ;AAkGI;EACE,iCAAA;AAhGN;;AAqGA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AAlGF;;AAqGA;EACE,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAlGF;;AAqGA;EACE;IACE,yBAAA;EAlGF;AACF;AAsGA;EACE;IACE,aAAA;EApGF;EAuGA;IACE,eAAA;EArGF;EAwGA;IACE,0BAAA;EAtGF;EAyGA;IACE,0BAAA;EAvGF;EA0GA;IACE,0BAAA;EAxGF;EA2GA;IACE,2DAAA;EAzGF;EA4GA;IACE,0BAAA;EA1GF;EA6GA;IACE,sBAAA;EA3GF;EA6GE;;IAEE,uBAAA;EA3GJ;AACF;AA+GA;EACE;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;EA7GF;EA+GE;IACE,eAAA;EA7GJ;EAkHE;IACE,aAAA;EAhHJ;EAoHA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;IACA,kBAAA;EAlHF;EAoHE;IACE,kBAAA;EAlHJ;EAsHA;IACE,kBAAA;EApHF;AACF","sourcesContent":[":root {\r\n  --primary-light: #eef2ff;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --warning-color: #f59e0b;\r\n  --text-dark: #1f2937;\r\n  --text-medium: #4b5563;\r\n  --text-light: #9ca3af;\r\n  --bg-light: #f9fafb;\r\n  --card-bg: #ffffff;\r\n  --border-light: #e5e7eb;\r\n  --border-radius: 12px;\r\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n  --transition: all 0.3s ease;\r\n}\r\n\r\n.company-detail-container {\r\n  padding: 1rem;\r\n  background-color: #f4f6f8;\r\n  display: flex;\r\n  // min-height: 100vh;\r\n}\r\n\r\n.company-card {\r\n  background-color: var(--card-bg);\r\n  border-radius: var(--border-radius-primary);\r\n  box-shadow: var(--box-shadow);\r\n  width: 100%;\r\n  padding: 2rem;\r\n}\r\n\r\n.company-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1.5rem;\r\n  border-bottom: 1px solid var(--border-light);\r\n}\r\n\r\n.avatar {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.75rem;\r\n  font-weight: bold;\r\n  margin-right: 1.5rem;\r\n}\r\n\r\n.company-title {\r\n  h2 {\r\n    margin: 0;\r\n    color: var(--text-dark);\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.company-status {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  margin-top: 0.5rem;\r\n\r\n  &.active {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n\r\n  &.inactive {\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n    color: var(--danger-color);\r\n  }\r\n}\r\n\r\n.company-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.detail-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n\r\n  .icon {\r\n    color: var(--primary-color);\r\n    font-size: 1.25rem;\r\n    margin-top: 0.25rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    color: var(--text-light);\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    color: var(--text-dark);\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n\r\n    a {\r\n      color: var(--primary-color);\r\n      text-decoration: none;\r\n      \r\n      &:hover {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.role-badge {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n\r\n  &.enabled {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n\r\n  &.disabled {\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n    color: var(--danger-color);\r\n  }\r\n\r\n  &.success {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n\r\n  &.pending {\r\n    background-color: rgba(245, 158, 11, 0.1);\r\n    color: var(--warning-color);\r\n  }\r\n\r\n}\r\n\r\n.payment-status {\r\n  // padding: 4px 12px;\r\n  // border-radius: 12px;\r\n  // font-size: 0.85rem;\r\n  // font-weight: 500;\r\n  // text-transform: capitalize;\r\n  // display: inline-block;\r\n\r\n  display: inline-block;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  \r\n  &.success {\r\n    background-color: rgba(34, 197, 94, 0.1);\r\n    color: #16a34a;\r\n    border: 1px solid rgba(34, 197, 94, 0.2);\r\n  }\r\n  \r\n  &.pending {\r\n    background-color: rgba(251, 191, 36, 0.1);\r\n    color: #d97706;\r\n    border: 1px solid rgba(251, 191, 36, 0.2);\r\n  }\r\n  \r\n  &.failed {\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n    color: #dc2626;\r\n    border: 1px solid rgba(239, 68, 68, 0.2);\r\n  }\r\n  \r\n  &.free-trial {\r\n    background-color: rgba(59, 130, 246, 0.1);\r\n    color: #2563eb;\r\n    border: 1px solid rgba(59, 130, 246, 0.2);\r\n  }\r\n  \r\n  &.unknown {\r\n    background-color: rgba(107, 114, 128, 0.1);\r\n    color: #6b7280;\r\n    border: 1px solid rgba(107, 114, 128, 0.2);\r\n  }\r\n}\r\n\r\n// Company Permissions Section\r\n.company-permissions-section {\r\n  margin-top: 2rem;\r\n  padding-top: 2rem;\r\n  border-top: 1px solid var(--border-light);\r\n\r\n  .section-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 1.5rem;\r\n\r\n    .section-title {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.75rem;\r\n\r\n      .icon {\r\n        color: var(--primary-color);\r\n        font-size: 1.25rem;\r\n      }\r\n\r\n      h3 {\r\n        margin: 0;\r\n        color: var(--text-dark);\r\n        font-size: 1.25rem;\r\n        font-weight: 600;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.permissions-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, minmax(200px, 1fr));\r\n  gap: 1rem;\r\n\r\n  .permission-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 1rem;\r\n    background-color: white;\r\n    border: 1px solid var(--border-light);\r\n    border-radius: 8px;\r\n    transition: var(--transition);\r\n\r\n    &:hover {\r\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n    }\r\n\r\n    .permission-details {\r\n      flex: 1;\r\n\r\n      .permission-name {\r\n        font-weight: 600;\r\n        color: var(--text-dark);\r\n        font-size: 0.95rem;\r\n      }\r\n    }\r\n\r\n    // .toggle-switch {\r\n    //   width: 50px;\r\n    //   height: 24px;\r\n    //   background-color: #ccc;\r\n    //   border-radius: 12px;\r\n    //   position: relative;\r\n    //   cursor: pointer;\r\n    //   transition: var(--transition);\r\n\r\n    //   &.enabled {\r\n    //     background-color: #004A9A;\r\n    //   }\r\n\r\n    //   &.disabled {\r\n    //     background-color: #9ca3af;\r\n    //   }\r\n\r\n    //   .toggle-slider {\r\n    //     width: 20px;\r\n    //     height: 20px;\r\n    //     background-color: white;\r\n    //     border-radius: 50%;\r\n    //     position: absolute;\r\n    //     top: 2px;\r\n    //     left: 2px;\r\n    //     transition: var(--transition);\r\n    //     box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    //   }\r\n\r\n    //   &.enabled .toggle-slider {\r\n    //     transform: translateX(26px);\r\n    //   }\r\n\r\n    //   &.disabled .toggle-slider {\r\n    //     transform: translateX(0);\r\n    //   }\r\n    // }\r\n\r\n    .toggle-switch {\r\n  position: relative;\r\n  width: 50px;\r\n  height: 24px;\r\n  cursor: default; // Set to default as it's not interactive\r\n\r\n  input {\r\n    opacity: 0;\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n\r\n    &:checked + .slider {\r\n      background-color: var(--primary-color, #3b82f6);\r\n\r\n      &::before {\r\n        transform: translateX(26px);\r\n      }\r\n    }\r\n  }\r\n\r\n  .slider {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #d1d5db;\r\n    border-radius: 24px;\r\n    transition: all 0.3s ease;\r\n\r\n    &::before {\r\n      content: '';\r\n      position: absolute;\r\n      height: 18px;\r\n      width: 18px;\r\n      left: 3px;\r\n      top: 3px;\r\n      background-color: white;\r\n      border-radius: 50%;\r\n      transition: all 0.3s ease;\r\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\r\n    }\r\n  }\r\n}\r\n  }\r\n}\r\n\r\n// Court Details Section\r\n.court-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 1rem;\r\n\r\n  .court-detail-item {\r\n    padding: 1rem;\r\n    background-color: white;\r\n    border: 1px solid var(--border-light);\r\n    border-radius: 8px;\r\n    transition: var(--transition);\r\n\r\n    &:hover {\r\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n    }\r\n\r\n    .court-name {\r\n      font-weight: 600;\r\n      color: var(--text-dark);\r\n      font-size: 1rem;\r\n      margin-bottom: 0.5rem;\r\n    }\r\n\r\n    .court-info {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 0.25rem;\r\n\r\n      .court-state,\r\n      .court-code {\r\n        font-size: 0.85rem;\r\n        color: var(--text-medium);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Unique Names Section\r\n.unique-names-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 0.75rem;\r\n\r\n  .unique-name-item {\r\n    padding: 0.75rem 1rem;\r\n    background-color: var(--primary-light);\r\n    color: var(--primary-color);\r\n    border-radius: 8px;\r\n    font-weight: 500;\r\n    font-size: 0.9rem;\r\n    text-align: center;\r\n    transition: var(--transition);\r\n\r\n    &:hover {\r\n      transform: translateY(-1px);\r\n      box-shadow: 0 2px 8px rgba(67, 97, 238, 0.15);\r\n    }\r\n  }\r\n}\r\n\r\n// Subscription Details Section\r\n.subscription-details {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 1.5rem;\r\n\r\n  .subscription-item {\r\n    label {\r\n      display: block;\r\n      color: var(--text-light);\r\n      font-size: 0.75rem;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.5px;\r\n      margin-bottom: 0.25rem;\r\n    }\r\n\r\n    p {\r\n      margin: 0;\r\n      color: var(--text-dark);\r\n      font-size: 0.95rem;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}\r\n\r\n.company-actions {\r\n  margin-top: 2rem;\r\n  padding-top: 2rem;\r\n  border-top: 1px solid var(--border-light);\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: flex-end;\r\n\r\n  .edit-company-btn,\r\n  .back-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    padding: 0.75rem 1rem;\r\n    border-radius: 8px;\r\n    font-size: 0.9rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: var(--transition);\r\n    border: none;\r\n  }\r\n\r\n  .edit-company-btn {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n\r\n    &:hover {\r\n      background-color: #3c5ce6;\r\n      transform: translateY(-1px);\r\n    }\r\n  }\r\n\r\n  .back-btn {\r\n    background-color: transparent;\r\n    color: var(--text-medium);\r\n    border: 1px solid var(--border-light);\r\n\r\n    &:hover {\r\n      background-color: var(--bg-light);\r\n    }\r\n  }\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid rgba(67, 97, 238, 0.2);\r\n  border-top-color: var(--primary-color);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin: 0 auto;\r\n}\r\n\r\n.error-message {\r\n  color: var(--danger-color);\r\n  font-size: 1rem;\r\n  padding: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .company-detail-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .company-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .company-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .permissions-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .court-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .unique-names-grid {\r\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n  }\r\n\r\n  .subscription-details {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .company-actions {\r\n    flex-direction: column;\r\n\r\n    .edit-company-btn,\r\n    .back-btn {\r\n      justify-content: center;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .company-header {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    gap: 1rem;\r\n\r\n    .avatar {\r\n      margin-right: 0;\r\n    }\r\n  }\r\n\r\n  .detail-item {\r\n    .icon {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n\r\n  .permission-item {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: stretch;\r\n    text-align: center;\r\n\r\n    .permission-icon {\r\n      align-self: center;\r\n    }\r\n  }\r\n\r\n  .court-detail-item {\r\n    text-align: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
